import React from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { translateFr as tfr } from "@/i18n";

export default function PasswordChangeBanner() {
  const { user } = useAuth();
  if (!user?.must_change_password) return null;
  return (
    <div className="mx-4 mt-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 flex items-center gap-2 text-xs text-amber-500"
      data-testid="must-change-password-banner">
      <KeyRound className="h-3.5 w-3.5 shrink-0" />
      <span className="flex-1">{tfr("Sécurité : vous devez changer votre mot de passe initial.")}</span>
      <Link to="/settings/security" className="font-medium underline underline-offset-2 whitespace-nowrap"
        data-testid="must-change-password-link">
        {tfr("Changer maintenant")}
      </Link>
    </div>
  );
}
